import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const tiers = [
  {
    name: 'Free',
    price: '$0',
    period: 'forever',
    features: ['2 decks/month', 'Unlimited words', '10 articles/month', 'Anki export', 'Flashcard review'],
    cta: 'Get Started',
    featured: false,
  },
  {
    name: 'Pro',
    price: '$5',
    period: '/month',
    features: ['10 decks/month', 'Unlimited words', '25 articles/month', 'Anki export', 'Flashcard review'],
    cta: 'Subscribe',
    featured: true,
    priceId: process.env.REACT_APP_STRIPE_TIER1_PRICE_ID,
  },
  {
    name: 'Unlimited',
    price: '$10',
    period: '/month',
    features: ['Unlimited decks/month', 'Unlimited words', 'Unlimited articles/month', 'Anki export', 'Flashcard review'],
    cta: 'Subscribe',
    featured: false,
    priceId: process.env.REACT_APP_STRIPE_TIER2_PRICE_ID,
  },
];

export default function PricingPage() {
  const { user } = useAuth();

  const handleSubscribe = async (tierIndex: number) => {
    if (!user) {
      window.location.href = '/signup';
      return;
    }
    const tier = tiers[tierIndex];
    if (!tier.priceId) return;

    const checkoutUrl = process.env.REACT_APP_CHECKOUT_URL;
    if (!checkoutUrl) {
      alert('Checkout URL not configured. Set REACT_APP_CHECKOUT_URL in .env.local');
      return;
    }

    const token = await user.getIdToken();
    const res = await fetch(checkoutUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ priceId: tier.priceId }),
    });
    const { url } = await res.json();
    if (url) window.location.href = url;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-4">
          <Link to="/" className="text-xl font-bold text-primary-400">Yomitool</Link>
        </div>
        <h1 className="text-3xl font-bold text-center mb-2">Choose Your Plan</h1>
        <p className="text-slate-400 text-center mb-12">Start free, upgrade when you need more</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {tiers.map((tier, i) => (
            <div
              key={tier.name}
              className={`rounded-2xl p-6 ${
                tier.featured
                  ? 'bg-primary-600 ring-2 ring-primary-400 shadow-xl shadow-primary-600/20'
                  : 'bg-slate-800/60 border border-slate-700/50'
              }`}
            >
              <h3 className="text-lg font-semibold mb-1">{tier.name}</h3>
              <div className="mb-4">
                <span className="text-3xl font-bold">{tier.price}</span>
                <span className="text-sm text-slate-300 ml-1">{tier.period}</span>
              </div>
              <ul className="space-y-2 mb-6">
                {tier.features.map(f => (
                  <li key={f} className="flex items-center gap-2 text-sm">
                    <svg className="w-4 h-4 text-emerald-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className={tier.featured ? 'text-white' : 'text-slate-300'}>{f}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => tier.priceId ? handleSubscribe(i) : (window.location.href = user ? '/app' : '/signup')}
                className={`w-full py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  tier.featured
                    ? 'bg-white text-primary-700 hover:bg-slate-100'
                    : 'bg-slate-700 text-white hover:bg-slate-600'
                }`}
              >
                {tier.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
